export const isSameDay = (firstDate, secondDate) => {
  return (
    new Date(firstDate).getDate() === new Date(secondDate).getDate() &&
    new Date(firstDate).getMonth() === new Date(secondDate).getMonth() &&
    new Date(firstDate).getFullYear() === new Date(secondDate).getFullYear()
  );
};
